import React from 'react';

function LoadingSpinner({ size = 'medium', text = 'Loading...' }) {
  const spinnerSizes = {
    small: '16px',
    medium: '24px',
    large: '32px'
  };

  return (
    <div className={`loading-spinner loading-spinner--${size}`}>
      <div className="loading-spinner__spinner" />
      {text && (
        <span className="loading-spinner__text">
          {text}
        </span>
      )}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default LoadingSpinner;
